"use strict";
/**
 * Purpose: to include all of the types related to the MakeMyDeal Legacy Dealer schema (previously IMMDLDealer).
 */
Object.defineProperty(exports, "__esModule", { value: true });
